(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("ArcWeuiVue", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["ArcWeuiVue"] = factory(require("vue"));
	else
		root["ArcWeuiVue"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_129__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition